<template>
  <TransparentCard container-tag="section" container-class="achievments_prof">
    <div class="title">
      <div class="left">
        <BaseImage src="/static/images/profile_stats.svg" alt="Profile Stats" />
      </div>

      <div class="right">
        <h1>{{ $_translations.value.page_profile_overview_section_statistics_title }}</h1>
      </div>
    </div>

    <StatisticsStatsItem
      v-for="stats in statsList"
      :key="stats.id"
      :value="stats.value"
      :description="stats.description"
    />
  </TransparentCard>
</template>

<script setup>
import { computed } from 'vue';
import TransparentCard from '@/components/card/TransparentCard.vue';
import BaseImage from '@/components/image/BaseImage.vue';
import StatisticsStatsItem from '@/views/profileOverview/components/item/StatisticsStatsItem.vue';
import useAuthStore from '@/store/modules/auth.js';

const authStore = useAuthStore();

const statsList = computed(() => {
  const answersAccuracyRate = authStore.userStatistics.questionsPlayed > 0
    ? Math.ceil((authStore.userStatistics.correctQuestions / authStore.userStatistics.questionsPlayed) * 100)
    : 0;

  return [
    {
      id: 'points',
      value: authStore.user.totalPointsEarned,
      description: 'page_profile_overview_section_statistics_item_points',
    },
    {
      id: 'games',
      value: authStore.user.gamesPlayed,
      description: 'page_profile_overview_section_statistics_item_games',
    },
    {
      id: 'totalAnswers',
      value: authStore.userStatistics.questionsPlayed,
      description: 'page_profile_overview_section_statistics_item_answers_total',
    },
    {
      id: 'correctAnswers',
      value: authStore.userStatistics.correctQuestions,
      description: 'page_profile_overview_section_statistics_item_answers_correct',
    },
    {
      id: 'perfectGames',
      value: authStore.userStatistics.perfectGames,
      description: 'page_profile_overview_section_statistics_item_games_perfect',
    },
    {
      id: 'accuracyRateAnswers',
      value: `${answersAccuracyRate}%`,
      description: 'page_profile_overview_section_statistics_item_answers_accuracy_rate',
    },
  ];
});
</script>
